module.exports = __webpack_public_path__ + "img/new_index_cases26.06496315.png";